module.exports = __webpack_public_path__ + "img/683-77574c.png";